module.exports = "/_next/static/images/632823ad72023ad2345c1ea28bd1800f-complexity@xs-1x.jpg.webp";